import { createContext } from 'react';
import { IItemForGetShortInfo, IDishPositionItemV2 } from 'types';

export type TTypeOfChangeDishPositionModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSave'
	| 'success'
	| 'error';

export interface IChangeDishPositionState {
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	IDSelectedSubCategory: Nullable<string>;
	positionsData: IDishPositionItemV2[];
	typeOfModalWindow: TTypeOfChangeDishPositionModalWindow;
	isVisibleAdditionalRestaurantsModal: boolean;
	isApplyToOne: boolean;
	selectedAdditionalRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
}

export const changeDishPositionInitialState: IChangeDishPositionState = {
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedCategory: null,
	IDSelectedSubCategory: null,
	positionsData: [],
	typeOfModalWindow: null,
	isVisibleAdditionalRestaurantsModal: false,
	isApplyToOne: false,
	selectedAdditionalRestaurants: [],
	fetchedRestaurants: [],
};

export interface IChangeDishPositionContext extends IChangeDishPositionState {
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDCategory(value: Nullable<string>): void;
	setIDSubCategory(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setPositionsData(data: IDishPositionItemV2[]): void;
	changeTypeOfModalWindow(value: TTypeOfChangeDishPositionModalWindow): void;
	setVisibleAdditionalRestaurantsModal(value: boolean): void;
	toggleApplyToOne(): void;
	setAdditionalRestaurants(value: string[]): void;
	setFetchedRestaurants: (value: IItemForGetShortInfo[]) => void;
}

export const ChangeDishPositionContext = createContext<IChangeDishPositionContext>({
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDCategory: () => undefined,
	setIDSubCategory: () => undefined,
	resetSelectedControls: () => undefined,
	setPositionsData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setVisibleAdditionalRestaurantsModal: () => undefined,
	toggleApplyToOne: () => undefined,
	setAdditionalRestaurants: () => undefined,
	setFetchedRestaurants: () => undefined,
	...changeDishPositionInitialState,
});
